import React from 'react';
import { Button, Typography } from '@/components/common';

export const EmptyCases = () => {
	return (
		<div className="space-y-6 text-center">
			<Typography type="semibold-30">No Ongoing Cases</Typography>
			<Typography type="regular-18">
				{`You haven’t created any cases yet`}
			</Typography>
			<div className="flex justify-center">
				<Button
					href="/lawyerapp/cases/create"
					decoration="primary"
					size="medium"
				>
					Create a new case
				</Button>
			</div>
		</div>
	);
};
